"use client";
import { useEffect } from "react";
import {
  registerAnalyticsProperties,
  unregisterAnalyticsProperties,
} from "./client";

type AnalyticsPropertiesProps = {
  properties: Record<string, string | number | boolean | null | undefined>;
};

export function AnalyticsProperties({ properties }: AnalyticsPropertiesProps) {
  useEffect(() => {
    registerAnalyticsProperties(properties);

    return () => {
      unregisterAnalyticsProperties(Object.keys(properties));
    };
  }, [properties]);

  return null;
}
